<template>
  <section class="section_bg container-fluid pt-2 pb-2   first_page" >

    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div class="d-flex justify-content-center"  v-if="is_load " >
      <div class="  ">
        <div class="second_section   block_row text-center pb-3 m-3 text-center" v-if="process_login==true">
          <h2>Идет авторизация</h2>
        </div>
        <div class="second_section   block_row text-center pb-3 m-3" v-if="process_login==false">
          <div class="alert alert-warning " v-if="$route.query && $route.query.nextUrl">
            <p v-if="is_iframe_vk==false && is_frame_tg==false">Для доступа   необходимо авторизоваться!</p>
            <p v-if="is_iframe_vk==true || is_frame_tg==true">Для доступа  необходимо авторизоваться!</p>
            <p v-if="is_iframe_vk==true">Для работы приложения необходим доступ к отправке сообщений. Это необходимо для работы системы уведомлений. Мы не будем вам слать спам.</p>
            <p v-if="is_iframe_vk==true">Также для работы приложения необходим ваш email. Ваш email нигде не будет показываться и отображаться. Мы будем только раз в неделю слать вам письмо о уведомлениях которые вы пропустили за неделю. Данные которые мы используем описаны в <router-link  tag="a"
                :to="{path: path_user_agrement_link}">правилах</router-link> </p>

          </div>

          <!--            <p  ><button v-if="type=='telegram'" class="btn side4" @click="changeType('telegram')"  >Telegram</button> <button v-if="type=='matrix'" class="btn side3" @click="changeType('telegram')"  >Telegram</button> <button v-if="type=='matrix' && matrix_status==true" class="btn side4" @click="changeType('matrix')"  >Matrix.org</button> <button v-if="type=='telegram' && matrix_status==true" class="btn side2" @click="changeType('matrix')">Matrix.org</button></p>-->

          <div class="btn-wrapper" v-if="type=='telegram' && is_frame_tg==false  && is_show_form_register==true">
            <p><button @click="toogleFormRegister" class="btn">Назад <i class="fa fa-backward"></i></button></p>
            <div class="form-group">
              <label for="exampleInputEmail1">Email</label>
              <input type="text" v-model="user_form_register.email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Введите email">
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">Логин</label>
              <input type="text" v-model="user_form_register.login" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Введите логин">
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Пароль</label>
              <input type="password" v-model="user_form_register.password" class="form-control" id="exampleInputPassword1" placeholder="Введите пароль">
            </div>
            <div class="alert alert-warning" v-if="is_form_register_error" v-html="form_register_error_message">

            </div>
            <p><button @click="registerByForm" class="btn btn-second">Зарегистрироваться</button></p>
          </div>
          <div class="btn-wrapper" v-if="type=='telegram'  && is_frame_tg==false &&  form_login_status==true &&  is_show_form_login==true">

            <div class="form-group">
              <label for="exampleInputEmail1">Логин</label>
              <input type="text" v-model="user_form.login" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Введите логин">
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Пароль</label>
              <input type="password" v-model="user_form.password" class="form-control" id="exampleInputPassword1" placeholder="Введите пароль">
            </div>
            <div class="alert alert-warning" v-if="is_form_login_error" v-html="form_login_error_message">

            </div>
            <p  ><button @click="loginByForm" class="mb-2 btn btn-second">Войти</button> <b v-if="form_register_status==true">или</b>&nbsp; <button v-if="form_register_status==true" @click="toogleFormRegister" class="btn">зарегистрироваться</button></p>
          </div>
          <div class="btn-wrapper text-center m-2" v-if="type=='telegram'  " >
<!--            <div class="mb-2" v-if="form_login_status==true">-->
<!--              <p><button @click="toogleFormLogin" class="btn btn-second">войти</button></p>-->
<!--            </div>-->
<!--            <div class="mb-2" v-if="form_register_status==true">-->
<!--              <p><button @click="toogleFormRegister" class="btn btn-second">зарегистрироваться</button></p>-->
<!--            </div>-->
            <div   v-if="is_iframe_vk==false && is_frame_tg==false && telegram_status==true && is_show_form_register==false">
              <p><button   @click="LoginFromBot"
                  class="btn btn-second">Авторизоваться через<br>
                Telegram
                Бота</button></p>
              <p>

              </p>

            </div>
            <div v-if="is_iframe_vk==false && is_frame_tg==false && telegram_status==true && is_show_form_register==false">

              <TelegramWidgetLogin v-if="istgbot" id="telegram_login"
                  mode="callback"
                  requestAccess="write"
                  :telegram-login="telegram_bot"

                  @callback="telegramLoginCallback"/>
            </div>
            <div   v-if="is_iframe_vk==false && is_frame_tg==true">
              <p v-if="is_proccess_login_inside_tg==false"><button   @click="LoginInsideTG"
                  class="btn btn-second">Авторизоваться внутри<br>
                Telegram
              </button></p>
              <p v-if="is_proccess_login_inside_tg==true">идет авторизация..</p>
              <div class="alert alert-danger" v-if="is_inside_tg_error">
                <p>{{ is_inside_tg_error_message }}</p>
              </div>

            </div>
            <div class="col-12"  @click="LoginVkIframe" v-if="is_iframe_vk==true">
              <p><button
                  class="btn btn-second">Авторизоваться в ВК</button></p>
            </div>

            <div class="" v-if="OAUTH_providers.length>0 && is_iframe_vk==false && is_frame_tg==false && is_show_form_register==false">
              <div class=" mb-2" v-for="(oauth_provider,oauth_key) in OAUTH_providers" :key="oauth_key"><p><button @click="openOauthURL(oauth_provider.url)" class="btn btn-second"  >Авторизоваться через<br> {{ oauth_provider.title }}</button></p></div>
            </div>


            <div class="">
              <p> <br><router-link  tag="a" class="btn"
                  :to="{path: path_user_agrement_link}">Пользовательское<br>соглашение</router-link></p>
            </div>
            <!--              <div class="row">-->
            <!--              <vue-telegram-login v-if="istgbot && !isMobile()"  id="telegram_login"-->
            <!--                                  mode="callback"-->
            <!--                                  requestAccess="write"-->
            <!--                                  :telegram-login="telegram_bot"-->

            <!--                                  @callback="telegramLoginCallback"/></div>-->

          </div>

        </div>





      </div>
    </div>
  </section>
</template>
<script>
import {Base64} from 'js-base64';
import UserModel from "@/models/UserModel";
import TelegramWidgetLogin from "@/components/Custom/TelegramWidgetLogin";
import Api from "../models/Api";
import {eventBus} from "../main";
import Vue from "vue";
import axios from "axios";
import { loadScript } from "vue-plugin-load-script";
import bridge from "@vkontakte/vk-bridge";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "Login",
  components: {
    LoadingBlock,
    TelegramWidgetLogin
  },
  data() {
    var app = this;

    return {
      'OAUTH':'',
      'OAUTH_providers':[],
      'oauth_url':"",
      process_login:false,
      'user_form':{
        'login':'',
        'password':''
      },
      'user_form_register':{
        'login':'',
        'password':'',
        'email':''
      },
      'is_inside_tg_error':false,
      'is_inside_tg_error_message':'',
      'is_proccess_login_inside_tg':false,
      'is_form_register_error':false,
      'form_register_error_message':'',
      'is_form_login_error':false,
      'form_login_error_message':'',
      'is_load':false,
      'istgbot': false,
      'telegram_status':false,
      "telegram_bot": null,
      'random_code': '',
      'islogin':false,
      'is_show_form_login':false,
      'is_show_form_register':false,
      'form_login_status':true,
      'form_register_status':false,
      'is_iframe_vk':false,
      'is_frame_tg':false,
      'result_frame_vk':false,
      'result_frame_vk2':false,
      'result_frame_vk3':'',
      'timer_check_code': '',
      'type':'telegram',
      'key':null,
      'matrix':{
        "host":"https://matrix.org",
        "username":"",
        "password":"",
      },
      'is_show_matrix_enter':false,
      'matrix_frame_url':'',
      'is_matrix_error':false,
      'matrix_error':'',
      "matrix_bot":"",
      "matrix_window":"current",
      'matrix_status':false,
      "user_agrement_link":"",
      "path_user_agrement_link":'',
      'vk_group_id':null,

    }
  },
  mounted: async function () {

    var app=this;



    Api.loadLoginInfo(function(data){
      UserModel.logout();
      app.is_iframe_vk=app.checkIsVK();





      app.OAUTH_providers=data.oauth_list;

      if(data.telegram && data.telegram.status==true){
        app.telegram_bot = data.telegram.bot_username;
        app.telegram_status=true;
      }
      if(data.form_login && data.form_login==true){
        app.is_show_form_login=true;
        app.form_login_status=true;
      }
      if(data.vk_group_id){
        app.vk_group_id=data.vk_group_id;
      }
      if(data.form_register_status && data.form_register_status==true){
        app.form_register_status=true;
      }

      app.user_agrement_link=Vue.config.USER_AGREMENT;
      var new_url=new URL(app.user_agrement_link);
      app.path_user_agrement_link=new_url.pathname;
      app.matrix_bot="";
      app.matrix_status=false;


      var user=UserModel.get();
      if(user && user.last_id){
        app.$router.push({name:'landing'});
      }
      app.random_code = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);

      if(app.telegram_status && app.is_frame_tg==false){
        app.LoginCheckCode();
        app.timer_check_code = setInterval(app.LoginCheckCode, 10000);
        app.istgbot = true;
      }

      app.checkInsideTG();

      app.is_load=true;
      if(app.is_frame_tg==true){
         app.LoginInsideTG();
      }
    })


  },
  methods:{
    openOauthURL(url){
      var app=this;
      if(app.$route.query && app.$route.query.nextUrl) {
        localStorage.setItem('nextUrl',app.$route.query.nextUrl);
      }
      document.location.href=url;
    },
    checkInsideTG(){
      var app=this;
      // if(!window.location.hash.includes('tgWebAppData')  && localStorage.getItem("tgHash")!=null){
      //   var decodedJson=JSON.parse(localStorage.getItem("tgHashJS"));
      //
      //
      //   if(decodedJson.hashTG) {
      //     var newQuery={
      //
      //     }
      //
      //     if(app.$route.query && app.$route.query.nextUrl) {
      //       var arr_nextUrl=app.$route.query.nextUrl.split("#");
      //       newQuery["nextUrl"]=arr_nextUrl[0];
      //
      //
      //
      //     }
      //     localStorage.setItem("is_tg_reload",true);
      //     var newURL="/login";
      //     if(newQuery.nextUrl){
      //       newURL=newURL+"?nextUrl="+newQuery.nextUrl
      //     }
      //     newURL=newURL+decodedJson.hashTG;
      //     //window.location.replace(newURL);
      //     app.$router.replace({path: "/login", hash:decodedJson.hashTG,query: newQuery});
      //
      //   }
      //
      //   //document.location.reload();
      //
      // }

   //   else {
     //

        if( localStorage.getItem("tg_inside_init_data")!=null ){
          app.is_frame_tg=true;
        }
  //    }


    },
    registerByForm(){
      var app=this;
      app.is_form_register_error=false;
      Api.startuserRegister(app.user_form_register,function(data){

        UserModel.set(data.user,true);
        app.redirectAfterLogin();
      },function(err){


        if(err.response.data.errors && Object.entries(err.response.data.errors).length>0){
          var final_err_message='';
          for (const [key, value] of Object.entries(err.response.data.errors)) {
            for (const [key_obj, value_obj] of Object.entries(value)) {

              final_err_message=final_err_message+'<p>'+value_obj+'</p>';
            }

          }
          app.form_register_error_message=final_err_message;
          app.is_form_register_error=true;
        }else {
          app.form_register_error_message=err.response.data.message;
          app.is_form_register_error=true;
        }



      });
    },
    loginByForm(){
      // 'is_form_login_error':false,
      //     'form_login_error_message':'',

      var app=this;
      app.is_form_login_error=false;
      Api.submitLoginandPass(app.user_form,function(data){

        UserModel.set(data.user,true);
        app.redirectAfterLogin();
      },function(err){


        if(err.response.data.errors && Object.entries(err.response.data.errors).length>0){
          var final_err_message='';
          for (const [key, value] of Object.entries(err.response.data.errors)) {
            for (const [key_obj, value_obj] of Object.entries(value)) {

              final_err_message=final_err_message+'<p>'+value_obj+'</p>';
            }

          }
          app.form_login_error_message=final_err_message;
          app.is_form_login_error=true;
        }else {
          app.form_login_error_message=err.response.data.message;
          app.is_form_login_error=true;
        }



      });

    },
    toogleFormLogin(){
      if(this.is_show_form_login==true){
        this.is_show_form_login=false;
      }else {
        this.is_show_form_login=true;
      }

    },
    toogleFormRegister(){
      if(this.is_show_form_register==true){
        this.is_show_form_register=false;
        this.is_show_form_login=true;
      }else {
        this.is_show_form_register=true;
        this.is_show_form_login=false;
      }
    },
    checkIsVK(){
      if (localStorage.getItem("isVkIframe") != null) {
        var result_vk_iframe=localStorage.getItem("isVkIframe");
        if(result_vk_iframe=="on"){
          return true;
        }else {
          return false;
        }
      }else {
        return false;
      }


    },
    setMatrixWindow(window_value){
      this.matrix_window=window_value;
    },
    LoginMatrix(){
      var host=this.matrix.host;
      var frame_url=host+'/_matrix/static/client/login/';
      this.matrix_frame_url=frame_url;
      this.is_show_matrix_enter=true;
      // var user=this.matrix;
      // Api.loginByMatrix(user,function(){},function(){
      //
      // });
    },
    changeType(type){
      this.type=type;
      return false;
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    async checkIsNotifyVKIframe(){
      var app=this;

      var result=  await app.sendRequestVkNotify();
      return result;
    },
    async sendRequestVkNotify(callback,err){
      var app=this;
      bridge.send('VKWebAppAllowMessagesFromGroup', {
        group_id: parseInt(app.vk_group_id),
        key: Date.now().toString()
      })
      .then((data) => {
        if (data.result) {

          return callback();
          // Пользователь разрешил отправку сообщений от имени сообщества
        }else {
          return err();
        }
      })
      .catch((error) => {
        // Ошибка
        console.log(error);
        return err();
      });
    },
    async  LoginVkIframe(){
      var app=this;
      app.is_load=false;
      app.sendRequestVkNotify(async function(){

        var data_launch=  await bridge.send('VKWebAppGetLaunchParams');
        console.log('data_launch is',data_launch);
        app.result_frame_vk=true;
        var data_auth=await bridge.send('VKWebAppGetAuthToken', {
          app_id: data_launch.vk_app_id,
          scope: ''
        });
        console.log('data_auth is',data_auth);
        var data_email=await bridge.send('VKWebAppGetEmail');

        console.log('data_email is',data_email);



        var new_json=data_email;
        new_json.access_token=data_auth.access_token;


        app.result_frame_vk3=JSON.stringify(data_email)+'|'+data_auth.access_token;
        app.result_frame_vk2=true;

        Api.checkVkIframeAuth(new_json,function(data){


          if(data.user){
            app.is_load=true;
            UserModel.set(data.user,true);
            app.redirectAfterLogin();

          }
        });
      },function(){
        app.is_load=true;
      })

    },
    LoginInsideTG(){
      var app=this;

      app.is_inside_tg_error=false;

      if(window && window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData){
        app.is_proccess_login_inside_tg=true;

        Api.loginByHash(window.Telegram.WebApp.initData,function(data){

          localStorage.setItem('api_token', data.user.api_token);
          UserModel.set(data.user);
          localStorage.setItem("isPWA",true);
          app.is_proccess_login_inside_tg=false;

          app.redirectAfterLogin(true);

        },function(err_message){
          app.is_proccess_login_inside_tg=false;
          app.is_inside_tg_error=true;
          app.is_inside_tg_error_message="Ошибка1:"+err_message;

        });
      }else if(localStorage.getItem("tgHash")!=null){
        var decodedTgHash=Base64.atob(localStorage.getItem("tgHash"));
        var decodedJson=JSON.parse(localStorage.getItem("tgHashJS"));


        if(decodedJson.hashTG) {
         // window.location.hash = decodedJson.hashTG;
         // app.is_load          = false;

                var initData=JSON.parse(localStorage.getItem("tg_inside_init_data"));
              app.is_proccess_login_inside_tg=true;
              Api.loginByHash(initData,function(data){

                localStorage.setItem('api_token', data.user.api_token);
               UserModel.set(data.user);
                localStorage.setItem("isPWA",true);
                app.is_proccess_login_inside_tg=false;

                app.redirectAfterLogin(true);

              },function(err_message){
                app.is_proccess_login_inside_tg=false;
                app.is_inside_tg_error=true;
                app.is_inside_tg_error_message="Ошибка2:"+err_message;

              });


        }


      }
    },
    LoginFromBot() {

      var app = this;
      var url='https://t.me/'+app.telegram_bot+'?start=login'+app.random_code;



      app.timer_check_code = setInterval(app.LoginCheckCode, 2000);
      app.LoginCheckCode();
      app.$router.absUrl(url);
    },
    telegramLoginCallback(user) {

      // gets user as an input
      // id, first_name, last_name, username,
      // photo_url, auth_date and hash

      var app = this;


      axios.post(Vue.config.API_URL + `login`, user)
      .then(response => {

        if (response.data.type == "success") {

          var data=response.data;


          UserModel.set(data.user,true);
          clearInterval(app.timer_check_code);
          app.redirectAfterLogin();
        } else {
          alert(response.data.message);
        }
      })
      .catch(e => {

      })
    },
    redirectAfterLogin(need_reload=false){
      var app=this;
      app.process_login=true;

      if(localStorage.getItem("is_tg_reload")!=null){
        localStorage.removeItem("is_tg_reload");
      }

      if(localStorage.getItem("nextUrl")){

        var newQuery={};
        if(need_reload==true){
          newQuery["need_reload"]=true;
        }
        app.$router.push({path:localStorage.getItem("nextUrl"),query:newQuery});
        localStorage.removeItem('nextUrl');
      }else if(app.$route.query && app.$route.query.nextUrl){
        var newQuery={};
        if(need_reload==true){
          newQuery["need_reload"]=true;
        }
        app.$router.push({path:app.$route.query.nextUrl,query:newQuery});
        localStorage.removeItem('nextUrl');
      }else {
        var newQuery2={};
        newQuery2['after_login']='show'
        if(need_reload==true){

          newQuery2["need_reload"]=true;
        }
        app.$router.push({name:'landing',query: newQuery2});
      }

    },
    async LoginCheckCode() {




      if (this.islogin) {
        clearInterval(this.timer_check_code);
      }

      var app = this;
      var random_code = app.random_code;

      try{
        var type="normal";




        Api.LoginCheckCode(random_code,type, function (data) {


          if(data.user){

            UserModel.set(data.user,true);
            clearInterval(app.timer_check_code);
            app.redirectAfterLogin();
          }

        })
      }catch(e){

      }


    },
  }
};
</script>
<style>
</style>
